
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b94"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b94"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5IkBo", function(module, exports) {

$parcel$export(module.exports, "register", () => $42910af84dd64d95$export$6503ec6e8aabbaf, (v) => $42910af84dd64d95$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $42910af84dd64d95$export$f7ad0328861e2f03, (v) => $42910af84dd64d95$export$f7ad0328861e2f03 = v);
var $42910af84dd64d95$export$6503ec6e8aabbaf;
var $42910af84dd64d95$export$f7ad0328861e2f03;
"use strict";
var $42910af84dd64d95$var$mapping = new Map();
function $42910af84dd64d95$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$42910af84dd64d95$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $42910af84dd64d95$var$resolve(id) {
    var resolved = $42910af84dd64d95$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$42910af84dd64d95$export$6503ec6e8aabbaf = $42910af84dd64d95$var$register;
$42910af84dd64d95$export$f7ad0328861e2f03 = $42910af84dd64d95$var$resolve;

});

var $6b38869886a4f8c2$exports = {};

(parcelRequire("5IkBo")).register(new URL("", import.meta.url).toString(), JSON.parse('["62Y5v","index.1a661bd6.js","ktczW","Async.782ef14d.js"]'));


//# sourceMappingURL=index.runtime.8fca8a16.js.map
